import { useQuery } from "@tanstack/react-query";

import { supabase } from "../../../data/supabase/client";
import { CoachingArtifact } from "./useCoachingArtifacts";

interface UseCoachingArtifactParams {
  id: string | null;
  tenantId: string | null;
  permittedEmails: string[] | null;
  enabled?: boolean;
}

export const useCoachingArtifact = ({ id, tenantId, permittedEmails, enabled = true }: UseCoachingArtifactParams) => {
  return useQuery({
    queryKey: ["coaching-artifact", id, tenantId, permittedEmails],
    queryFn: async () => {
      if (!id) {
        throw new Error("Artifact ID is required");
      }

      let query = supabase
        .from("coaching_artifact")
        .select("*")
        .eq("id", id)
        .eq("tenant_id", tenantId as string)
        .is("deleted", null);

      if (permittedEmails && permittedEmails.length > 0) {
        query = query.in("agent_email", permittedEmails.map(email => email.toLowerCase()));
      }

      const { data, error } = await query.single();

      if (error) {
        throw error;
      }

      return data as unknown as CoachingArtifact;
    },
    enabled: enabled && !!id
  });
};
